import React, { useState } from 'react';
import { message } from 'antd';
import DefaultForm from 'components/form/DefaultForm';
import DefaultModal from 'components/modal/DefaultModal';
import { theme } from 'utils/style/theme';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { handleMessage } from 'utils/helper/message';
import PrimaryButton from 'components/button/PrimaryButton';
import InputStyled from 'components/InputStyled';
import { IVisible } from '../AssetsPage';
import { assetsApis } from 'apis/assets/assetsApis';
import UploadImage from './UploadImage';
/**
 * * 리소스 - 배경 수정 모달
 */

interface IProps {
  visible: IVisible;
  setVisible: (e: any) => void;
  selectedData: any;
  setSelectedData: React.Dispatch<any>;
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>;
  refresh: boolean;
  type: string;
}

const UpdateModal = ({
  visible,
  setVisible,
  selectedData,
  setSelectedData,
  setRefresh,
  refresh,
  type,
}: IProps) => {
  const { t } = useTranslation();

  const handleClose = () => {
    setVisible({ ...visible, edit: false });
  };
  const [loading, setLoading] = useState<boolean>(false);
  /// 서버 전송
  const handleSubmit = async () => {
    if (selectedData) {
      const postData = {
        update: selectedData,
      };
      try {
        setLoading(true);
        await assetsApis.assetsUpdate(type, selectedData.id, postData);
        setRefresh(!refresh);
        setVisible(false);
        setLoading(false);
        handleMessage(message, 'success', 'Success');
      } catch (err) {
        console.log('update error', err);
        setLoading(false);
        handleMessage(message, 'error', 'Error');
      }
    }
  };

  const handleInputChange = (e, type: string) => {
    if (selectedData) {
      const cloneData = JSON.parse(JSON.stringify(selectedData));
      cloneData[type] =
        type === 'game_scale' ? Number(e.target.value) : e.target.value;
      setSelectedData(cloneData);
    }
  };
  return (
    <DefaultModal
      title={
        type === 'bg'
          ? t('assets.modal.background.edit.title')
          : t('assets.modal.minicut.edit.title')
      }
      visible={visible.edit}
      onCancel={handleClose}
      footer={
        <ButtonWrapper>
          <PrimaryButton
            text={t('updateStory.form.buttonSubmit')}
            height='40px'
            width='fit-content'
            bgColor={theme.colors.blue_500}
            textColor='#ffffff'
            fontWeight={theme.fontWeights.medium}
            fontSize={theme.fontSizes.normal}
            border={`1px solid ${theme.colors.blue_500}`}
            rounded='6px'
            hoverBgColor={theme.colors.blue_600}
            activeBgColor={theme.colors.blue_800}
            selectedBgColor={theme.colors.blue_700}
            onClick={handleSubmit}
            loading={loading}
          />
        </ButtonWrapper>
      }
    >
      <DefaultForm>
        <HeaderWrapper>
          <p>
            {t(
              'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.backgroundContent.editBackgroundModal.title',
            )}{' '}
            : {selectedData?.id}
          </p>
        </HeaderWrapper>
        <FormWrapper>
          <div>
            <p className='title'>
              {t(
                'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.backgroundContent.editBackgroundModal.backgroundNameID',
              )}
            </p>
            <InputStyled
              value={selectedData?.image_name}
              onChange={(e) => {
                handleInputChange(e, 'image_name');
              }}
              maxLength={30}
            />
            <p className='length-subtext'>
              {typeof selectedData?.image_name?.length === 'number'
                ? `${selectedData?.image_name?.length}/30 characters`
                : '0/30 characters'}
            </p>
          </div>
          <div>
            <p className='title'>
              {t(
                'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.backgroundContent.editBackgroundModal.gameScale',
              )}
            </p>
            <InputStyled
              value={selectedData?.game_scale}
              onChange={(e) => {
                handleInputChange(e, 'game_scale');
              }}
              maxLength={30}
              type='number'
            />
          </div>
          <UploadImage
            type={type}
            data={selectedData}
            setData={setSelectedData}
            hideRequired={true}
          />
        </FormWrapper>
      </DefaultForm>
    </DefaultModal>
  );
};

export default UpdateModal;

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  p {
    color: ${theme.colors.dark_500};
    font-weight: ${theme.fontWeights.bold};
    font-size: ${theme.fontSizes.md};
  }
`;

const FormWrapper = styled.div`
  & > * + * {
    margin-top: 16px;
  }
  .title,
  .length-subtext {
    font-size: ${theme.fontSizes.sm};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
  }
  .length-subtext {
    margin-top: 8px !important;
    font-size: ${theme.fontSizes.normal};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${theme.colors.dark_200};
  }
  .ant-input-show-count-suffix {
    display: none;
  }
  .remove {
    display: flex;
    justify-content: end;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
`;
